import React, { useState } from "react";
import { useOperation } from "../../Context/OperationContext";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  selectWrapper: {
    marginTop: "20px",
    position: "relative",
    width: "100%",
    maxWidth: 320,
  },
  miningSelector: {
    width: "100%",
    padding: "16px 50px 16px 20px",
    fontSize: 14,
    fontWeight: 500,
    color: "#333",
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: 12,
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    cursor: "pointer",
    outline: "none",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
    "&:hover": {
      borderColor: "#d0d0d0",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
    },
    "&:focus": {
      borderColor: "#4a90e2",
      boxShadow: "0 0 0 3px rgba(74, 144, 226, 0.1)",
    },
    "& option": {
      padding: 10,
      fontSize: 16,
    },
  },
  selectIcon: {
    position: "absolute",
    top: "50%",
    right: 20,
    transform: "translateY(-50%)",
    pointerEvents: "none",
    width: 20,
    height: 20,
    "& svg": {
      fill: "#666",
      transition: "fill 0.3s ease",
    },
  },
  filterIcon: {
    fill: "#666",
    transition: "fill 0.3s ease",
  },
  // Hover and focus states for the icon
  selectHovered: {
    "& $filterIcon": {
      fill: "#333",
    },
  },
  selectFocused: {
    "& $filterIcon": {
      fill: "#4a90e2",
    },
  },
}));

const MiningSiteSelector = () => {
    const classes = useStyles();
    const { miningSite, setMiningSite } = useOperation();
    const miningSites = JSON.parse(localStorage.getItem('miningSites'));
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    return (
      <Grid item md={12}>
        <div className={classes.selectWrapper}>
          <select 
            onChange={(e) => setMiningSite(e.target.value)} 
            value={miningSite} 
            className={classes.miningSelector}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          >
            <option value="">Todas las Plantas</option>
            {miningSites.map((item, index) => (
              <option key={index} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          <div className={classes.selectIcon}>
            <svg 
              viewBox="0 0 24 24" 
              className={classes.filterIcon}
              style={{
                fill: isFocused ? "#4a90e2" : isHovered ? "#333" : "#666"
              }}
            >
              <path 
                d="M3 4h18v2.172l-7 7V20l-4-2v-4.828l-7-7V4z" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                fill="none" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </Grid>
    );
};

export default MiningSiteSelector;
